import React, {useContext, useEffect, useState} from "react";
import {Select, Row, Col, Button} from "antd";
import {AppContext} from "../../contexts/app-context";
import GoogleAndroidAppLink from "../google-android-app-link";
import Cookies from 'js-cookie';
import {useLocation} from "react-router-dom";
import RegionSelect from "./region-select";
import SelectField from "../select-field";
import { userServices } from "../../services";
import { ACCESS_TO_ALL_DELIVERIES_ITEMS, ACCESS_TO_ANY_DELIVERIES_ITEMS } from "../../helpers/user_permission.helper";
import { consignorService } from "../../services";

import i18n from "../../i18n";

export default function TopFilter() {
  const {Option} = Select;
  const appContext = useContext(AppContext);
  const [clearFilterFlag, setClearFilterFlag] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const path = useLocation().pathname.split("/").slice(-1);
  const {regionsLoadings, regionsUnloadings} = appContext.filter;


  const getCookies = (name) => {
    let value = {};
    if (Cookies.get(`${name}-${path}`)) {
      Cookies.get(`${name}-${path}`)
        .split(",")
        .map((item) => {
          const itemArr = item.split(': ')
          if (itemArr[1] !== '') {
            Object.assign(value, {[itemArr[0]]: itemArr[1].split('|').map((item) => Number(item))});
          } else {
            Object.assign(value, {[itemArr[0]]: []});
          }
        })
    }
    return value;
  }

  const [selectedRegionsLoading, setSelectedRegionsLoading] = useState(getCookies("regionsLoading"));
  const [selectedRegionsUnloading, setSelectedRegionsUnloading] = useState(getCookies("regionsUnloading"));
  const [selectedSorting, setSelectedSorting] = useState(appContext.filter.selectedSorting);
  const [consignors, setConsignors] = useState(null);


  let user = null;
  let isAccessToAllDeliveries = false;
  user = userServices.getUser()
  isAccessToAllDeliveries = user.isAccessTo(ACCESS_TO_ALL_DELIVERIES_ITEMS) && user.isAccessTo(ACCESS_TO_ANY_DELIVERIES_ITEMS);



  let cookieConsignors = getCookies('selectedConsignors');

  if (isAccessToAllDeliveries && cookieConsignors == null || cookieConsignors.data == null || cookieConsignors.data.length === 0) {
    cookieConsignors = [];
  } else if(isAccessToAllDeliveries){
    if (cookieConsignors.data != null && cookieConsignors.data.length > 0) {
      cookieConsignors = cookieConsignors.data.map((item) => {
        return Number(item);
      })
    } else {
      cookieConsignors = []
    }
  } else {
    cookieConsignors = []
  }

  let cookieExcConsignors = getCookies('excludedConsignors');

  if (isAccessToAllDeliveries && cookieExcConsignors == null || cookieExcConsignors.data == null || cookieExcConsignors.data.length === 0) {
    cookieExcConsignors = [];
  } else if(isAccessToAllDeliveries){
    if (cookieExcConsignors.data !== null && cookieExcConsignors.data.length > 0) {
      cookieExcConsignors = cookieExcConsignors.data.map((item) => {
        return Number(item);
      })
    } else {
      cookieExcConsignors = []
    }
  } else {
    cookieExcConsignors = []
  }

  const [selectedConsignors, setSelectedConsignors] = useState(cookieConsignors);
  const [selectedExcludedConsginors, setExcludedConsignors] = useState(cookieExcConsignors);

  const isEmptyFilter = !Boolean(Object.keys(selectedRegionsLoading).length) && !Boolean(Object.keys(selectedRegionsUnloading).length) && selectedSorting === 'default' && selectedConsignors.length === 0
    &&  selectedExcludedConsginors.length === 0;



  const onChangeRegionLoading = (values) => {
    setSelectedRegionsLoading(values);
  };
  const onChangeRegionUnloading = (values) => {
    setSelectedRegionsUnloading(values);
  };
  const onChangeFilterSort = (value) => {
    setSelectedSorting(value);
  };

  const onChangeSelectedConsignors = (value) => {
    setExcludedConsignors([]);
  }

  const setCookies = (name, values) => {
    if (values) {
      const valuesArr = [];
      for (const [key, value] of Object.entries(values)) {
        valuesArr.push(`${key}: ${value.toString().replaceAll(',', '|')}`);
      }
      Cookies.set(`${name}-${path}`, valuesArr.join());
    } else if (Cookies.get(`${name}-${path}`)) {
      Cookies.remove(`${name}-${path}`);
    }
  }

  useEffect(() => {
    if (!isFiltered && !isEmptyFilter || clearFilterFlag) {
      if (selectedConsignors.length > 0) {
        appContext.applyFilterParams(selectedRegionsLoading, selectedRegionsUnloading, selectedSorting, selectedConsignors, [], false);
      } else if (selectedExcludedConsginors.length > 0) {
        appContext.applyFilterParams(selectedRegionsLoading, selectedRegionsUnloading, selectedSorting, [], selectedExcludedConsginors, true);
      }
      if (!isFiltered && !isEmptyFilter) {
        setIsFiltered(true);
        setClearFilterFlag(true);
      }
    }
  }, [isFiltered, clearFilterFlag]);

  const applyFilterParams = () => {
    let isExcludeConsignors = false;
    if (selectedExcludedConsginors.length > 0) {
      isExcludeConsignors = true;
    }

    appContext.applyFilterParams(selectedRegionsLoading, selectedRegionsUnloading, selectedSorting, selectedConsignors, selectedExcludedConsginors, isExcludeConsignors);

    if (!isEmptyFilter) {
      setIsFiltered(true);
      setClearFilterFlag(true);
    }
    setCookies('regionsLoading', selectedRegionsLoading);
    setCookies('regionsUnloading', selectedRegionsUnloading);
    setCookies('selectedConsignors', {data: selectedConsignors});
    setCookies('excludedConsignors', {data: selectedExcludedConsginors});
  };

  const clearFilterParams = () => {
    setSelectedRegionsUnloading({});
    setSelectedRegionsLoading({});
    setSelectedSorting('default');
    setSelectedConsignors([]);
    setExcludedConsignors([]);

    setCookies('regionsLoading', {});
    setCookies('regionsUnloading', {});
    setCookies('selectedConsignors', {});
    setCookies('excludedConsignors', {});
    if (isFiltered) {
      setIsFiltered(false);
    }
  };

  function filter(inputValue, path) {
    return path.some(option => option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
  }

  const sortItems = appContext.filter.sort;
  const applyGoogleAndroidAppLink = false;

  function onChange(value) {
    console.log(value);
  }


  useEffect(() => {
    if (isAccessToAllDeliveries && consignors === null) {
      consignorService.getConsignorsList()
        .then((response) => {
          let formatted = response.map((item) => {
            return {
              id: item.Id,
              name: item.Name
            };
          })
          setConsignors(formatted);
        })
        .catch((response) => {

        })
    }
  }, [isAccessToAllDeliveries])




  return (
    <div className="filters-container">
      <div className="container">
        <div className="filters-container__wrapper">
          <Row gutter={22} style={{padding: "0", margin: "0", rowGap: "10px"}} type="flex" justify="start">
            <Col className="first-filter" xs={12} sm={12} md={8} lg={8} xl={8} style={{}}>
              <div style={{position: 'relative', height: '100%'}} id="regionsLoadings">
                <RegionSelect
                  regions={regionsLoadings}
                  prefix={'regionsLoadings'}
                  placeholder={i18n.t('components.filter.regionsLoadings')}
                  onChange={onChangeRegionLoading}
                  defaultValue={selectedRegionsLoading}
                />
              </div>
            </Col>
            <Col className="first-filter" xs={12} sm={12} md={8} lg={8} xl={8} style={{}}>
              <div style={{position: 'relative', height: '100%'}} id="regionsUnloadings">
                <RegionSelect
                  regions={regionsUnloadings}
                  prefix={'regionsUnloadings'}
                  placeholder={i18n.t('components.filter.regionsUnloadings')}
                  onChange={onChangeRegionUnloading}
                  defaultValue={selectedRegionsUnloading}
                />
              </div>
            </Col>
            <Col xs={12} sm={12} md={5} lg={5} xl={5} style={{}}>
              <Select
                size="default"
                onChange={(value) => {
                  onChangeFilterSort(value);
                }}
                defaultValue={selectedSorting}
                value={selectedSorting}
                style={{width: "100%", height: "100%"}}
              >
                {sortItems.map((sortItem) => {
                  return (
                    <Option key={sortItem.name} value={sortItem.name} selected={sortItem.selected}>
                      {sortItem.title}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col className="filters-buttons" xs={12} sm={12} md={3} lg={3} xl={3} style={{}}>
              <Button
                className="filters-button"
                type="primary"
                size="default"
                icon="search"
                htmlType="button"
                title={i18n.t('components.filter.buttons.apply')}
                onClick={applyFilterParams}
              />
              <Button
                className="filters-button filters-button--clear"
                type="primary"
                size="default"
                icon="close"
                disabled={isEmptyFilter}
                htmlType="button"
                title={i18n.t('components.filter.buttons.clear')}
                style={{border: "none", outline: "none", marginLeft: "5px"}}
                onClick={clearFilterParams}
              />
            </Col>
          </Row>
          { isAccessToAllDeliveries ?
          <Row gutter={22} style={{padding: "0", margin: "0", rowGap: "10px"}} type="flex" justify="start">
            <Col  xs={12} sm={12} md={8} lg={8} xl={8} style={{}}>
                <SelectField
                  mode='multiple'
                  name='consignors'
                  placeholder={i18n.t('components.filter.consignors.placeholder')}
                  values={consignors}
                  selectedValue={selectedConsignors}
                  onChange={(val) => {
                    setExcludedConsignors([]);
                    setSelectedConsignors(val);
                  }}
                  getErrors={()=>{}}
                  notFoundText={i18n.t('components.filter.consignors.notFoundText')}
                  style={{width: "100%",  marginTop: "15px"}}
                  allowClear={true}
                />

            </Col>
           <Col  xs={12} sm={12} md={8} lg={8} xl={8} style={{}}>
                <SelectField
                  mode='multiple'
                  name='excludedConsignors'
                  placeholder={i18n.t('components.filter.excludedConsignors.placeholder')}
                  values={consignors}
                  selectedValue={selectedExcludedConsginors}
                  onChange={(val) => {
                    setSelectedConsignors([]);
                    setExcludedConsignors(val);
                  }}
                  getErrors={()=>{}}
                  notFoundText={i18n.t('components.filter.excludedConsignors.notFoundText')}
                  style={{width: "100%",  marginTop: "15px"}}
                  allowClear={true}
                />

            </Col>
          </Row>
          : null
          }
        </div>
      </div>
      {/*<YoutubeVideoLink />*/}
      {applyGoogleAndroidAppLink ? <GoogleAndroidAppLink/> : null}
    </div>
  );
}
